import React, { useState  } from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import Icon, { IconType } from '../../atoms/icon/Icon'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import { percentage } from '../model/utils/formatters'
import { getLabelFromValue as getCentralBankLabel } from '../simulations/steps/region/CentralBankDropdown'

import './RoundResultsTablePage.scss'
import { ThemeColours } from '../../../types/theme'
import { useResultsContext } from './context/context'

interface Props {
  round: string
  data: ModelAPI.Reporting.NewsRoom
}

const getIconAndColour = (newsType: ModelAPI.Reporting.NewsInfoType): { icon: IconType, colour: ThemeColours } => {
  if (newsType === 'bear') {
    return { icon: 'newsBear', colour: 'yellow' }
  } else if (newsType === 'bull') {
    return { icon: 'newsBull', colour: 'blue' }
  } else if (newsType === 'emerging') {
    return { icon: 'newsEmerging', colour: 'primaryDark' }
  } else {
    return { icon: 'newsOutlook', colour: 'blue' }
  }
}

const RoundResultsNewsRoom: React.FC<Props> = ({ round, data }) => {
  const context = useResultsContext()
  const [show, setShow] = useState(context.noAnimations ? true : false)
  const scenario2IconAndColour = getIconAndColour(data.scenario2Type)
  const scenario3IconAndColour = getIconAndColour(data.scenario3Type)

  return (
    <VerticalGroup full center wide>
      <Text size='6xl' bold colour='primaryDark' className='mb-2'>News Room!</Text>
      <Text size='4xl' bold center colour='blue' className='mb-6'>
        Round {round}: Market Update
      </Text>
      <InlineGroup fullHeight spread verticalCenter style={{maxWidth: '1400px'}} className='pt-4 pb-4 pr-8 pl-8'>
        <VerticalGroup full spread className={show ? 'show-bids' : 'no-show-options'} style={{width: '100%'}}>
          <VerticalGroup>
            <Text size='4xl' bold className='mb-2'>{data.scenario1Title}</Text>
            <Text size="xl">{data.scenario1Desc}</Text>
          </VerticalGroup>
          <VerticalGroup>
            <Icon type={scenario2IconAndColour.icon} size={24} colour={scenario2IconAndColour.colour}></Icon>
            <Text size='4xl' bold className='mb-2'>{data.scenario2Title}</Text>
            <Text size="xl">{data.scenario2Desc}</Text>
          </VerticalGroup>
        </VerticalGroup>
        <VerticalGroup onClick={() => setShow(true)} style={{cursor: 'pointer', width: '100%'}} center className='mr-10 ml-10'>
          <Icon type='newsGlobe' colour='blue' style={{width: '90%', height: '100%'}}></Icon>
          <Text size='xs' center>Click on globe to show news.</Text>
        </VerticalGroup>
        <VerticalGroup full spread className={show ? 'show-bids' : 'no-show-options'} style={{width: '100%'}}>
          <VerticalGroup style={{width: '100%'}}>
            <Text size='4xl' bold right className='mb-2'>{getCentralBankLabel(data.centralBank)} Official Cash Rate: {percentage(data.cashRate)}</Text>
            <Text size="xl" right>{data.cashRateDesc}</Text>
          </VerticalGroup>
          <VerticalGroup style={{textAlign: 'right', display: 'block'}}>
            <Icon type={scenario3IconAndColour.icon} size={24} colour={scenario3IconAndColour.colour}></Icon>
            <Text size='4xl' right bold className='mb-2'>{data.scenario3Title}</Text>
            <Text size="xl" right>{data.scenario3Desc}</Text>
          </VerticalGroup>
        </VerticalGroup>
      </InlineGroup>
    </VerticalGroup>
  )
}

export default RoundResultsNewsRoom
